
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4VjzZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $170f29cf97bcf48d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $170f29cf97bcf48d$export$2e2bcd8739ae039 = {
    'editor-common-extensibility-extension-lozenge-editToggle.done.editing': "Redigeringen \xe4r klar",
    'editor-common-extensibility-extension-lozenge-editToggle.make.edits': "G\xf6r \xe4ndringar",
    'editor-common-extensibility.macro.button.configure': 'Konfigurera {macroName}',
    'fablric.editor.viewAllInserts': 'Visa alla infogningar',
    'fabric.editor.action': 'Uppgift',
    'fabric.editor.action.description': "Skapa och tilldela \xe5tg\xe4rdsuppgifter",
    'fabric.editor.addAltText': 'Alternativ text',
    'fabric.editor.addColumnLeft': "L\xe4gg till kolumn till v\xe4nster",
    'fabric.editor.addColumnRight': "L\xe4gg till kolumn till h\xf6ger",
    'fabric.editor.addCommentOnMedia': "L\xe4gg till kommentar",
    'fabric.editor.addImageBorder': "L\xe4gg till kant",
    'fabric.editor.addLoomVideo': 'Spela in en Loom-video',
    'fabric.editor.addLoomVideoComment': 'Spela in en Loom-videokommentar',
    'fabric.editor.addMediaFiles': "L\xe4gg till en bild, video eller fil",
    'fabric.editor.addRowAbove': "L\xe4gg till rad ovanf\xf6r",
    'fabric.editor.addRowBelow': "L\xe4gg till rad nedanf\xf6r",
    'fabric.editor.addUpdatedAltText': "L\xe4gg till alternativ text",
    'fabric.editor.ai.ai-panels.actionItemsPageDescription': "Anv\xe4nd Atlassian Intelligence f\xf6r att hitta \xe5tg\xe4rdsobjekt och visa dem i en panel",
    'fabric.editor.ai.ai-panels.actionItemsPageTitle': "Panel f\xf6r \xe5tg\xe4rdsobjekt (Beta)",
    'fabric.editor.ai.ai-panels.summarizePageDescription': "Anv\xe4nd Atlassian Intelligence f\xf6r att sammanfatta sidan och visa den i en panel",
    'fabric.editor.ai.ai-panels.summarizePageTitle': "Sammanfattningspanel f\xf6r sida (Beta)",
    'fabric.editor.ai.ai-smart-button.context.reference': "Markerat inneh\xe5ll",
    'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription': "Skapar inneh\xe5ll som ska infogas p\xe5 sidan",
    'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': "Sammanfattar sidans inneh\xe5ll",
    'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generera',
    'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': "Fr\xe5ga Atlassian Intelligence",
    'fabric.editor.ai.config.item.action.edit': 'Redigera',
    'fabric.editor.ai.config.item.action.insert': 'Infoga',
    'fabric.editor.ai.config.item.action.insertAtTop': "Infoga \xf6verst",
    'fabric.editor.ai.config.item.action.insertBelow': 'Infoga nedan',
    'fabric.editor.ai.config.item.action.replace': "Ers\xe4tt",
    'fabric.editor.ai.config.item.action.replaceTitle': "\xc4ndra titel",
    'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip': "Titeln f\xe5r inte \xf6verstiga {maxLength} tecken",
    'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': "\xd6ppna i chatt",
    'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo-agent',
    'fabric.editor.ai.config.item.atlas-shorten-update.description': "Kortar ner inneh\xe5llet f\xf6r att g\xf6ra det mer koncist",
    'fabric.editor.ai.config.item.atlas-shorten-update.title': "F\xf6rkorta uppdateringen",
    'fabric.editor.ai.config.item.bb.pr.description.description': "Skapar en beskrivning av pull-beg\xe4rande med en sammanfattning av \xe4ndringar",
    'fabric.editor.ai.config.item.bb.pr.description.title': "Ange beskrivning f\xf6r pull-beg\xe4rande",
    'fabric.editor.ai.config.item.brainstorm.description': "Genererar en lista med id\xe9er f\xf6r ett \xe4mne du anger",
    'fabric.editor.ai.config.item.brainstorm.promptHint': "Ge mig \xe4mnet\xa0\u2026",
    'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorma',
    'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorma',
    'fabric.editor.ai.config.item.changeTone.casualTone.description': "\xc4ndrar tonen f\xf6r inneh\xe5llet till informell",
    'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Informell',
    'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Informell',
    'fabric.editor.ai.config.item.changeTone.casualTone.title': "\xc4ndra tonen till informell",
    'fabric.editor.ai.config.item.changeTone.educationalTone.description': "\xc4ndrar tonen f\xf6r inneh\xe5llet till pedagogisk",
    'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Pedagogisk',
    'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Pedagogisk',
    'fabric.editor.ai.config.item.changeTone.educationalTone.title': "\xc4ndra tonen till pedagogisk",
    'fabric.editor.ai.config.item.changeTone.empatheticTone.description': "\xc4ndrar tonen f\xf6r inneh\xe5llet till empatisk",
    'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatisk',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatisk',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.title': "\xc4ndra tonen till empatisk",
    'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': "\xc4ndra tonen till\xa0...",
    'fabric.editor.ai.config.item.changeTone.neutralTone.description': "\xc4ndrar tonen f\xf6r inneh\xe5llet till neutral",
    'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutral',
    'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutral',
    'fabric.editor.ai.config.item.changeTone.neutralTone.title': "\xc4ndra tonen till neutral",
    'fabric.editor.ai.config.item.changeTone.professionalTone.description': "\xc4ndrar tonen f\xf6r inneh\xe5llet till professionell",
    'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionell',
    'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionell',
    'fabric.editor.ai.config.item.changeTone.professionalTone.title': "\xc4ndra tonen till professionell",
    'fabric.editor.ai.config.item.convertToBulletList.description': "Formaterar om inneh\xe5llet till en punktlista",
    'fabric.editor.ai.config.item.convertToBulletList.title': 'Konvertera till punktlista',
    'fabric.editor.ai.config.item.convertToTable.description': "Formaterar om inneh\xe5ll till en tabell med rubriker",
    'fabric.editor.ai.config.item.convertToTable.title': 'Konvertera till tabell',
    'fabric.editor.ai.config.item.draftReply.description': "Utarbetar ett svar baserat p\xe5 \xe4renden som liknar det du arbetar med",
    'fabric.editor.ai.config.item.draftReply.title': 'Skriv svar',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Korrigerar stavnings- och grammatikfel',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Stavning och grammatik',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Korrigera stavning och grammatik',
    'fabric.editor.ai.config.item.enhance.improveWriting.description': "F\xf6rb\xe4ttrar tydlighet, struktur och ton f\xf6r en mer engagerande och v\xe4lskriven text",
    'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': "F\xf6rb\xe4ttra skrivande",
    'fabric.editor.ai.config.item.enhance.improveWriting.title': "F\xf6rb\xe4ttra skrivande",
    'fabric.editor.ai.config.item.findActionItems.description': "Hittar \xe5tg\xe4rder i inneh\xe5llet du tillhandah\xe5ller",
    'fabric.editor.ai.config.item.findActionItems.title': "Hitta \xe5tg\xe4rder",
    'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint': "V\xe4lj nedan (fri generering \xe4r inaktiverad i Elevate just nu)",
    'fabric.editor.ai.config.item.generateContent.promptHint': "Skriv med AI eller v\xe4lj nedan",
    'fabric.editor.ai.config.item.improveDescription.default.description': "Omstrukturera \xe4rendebeskrivningen baserat p\xe5 \xe4rendetypen",
    'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': "F\xf6rb\xe4ttra beskrivning",
    'fabric.editor.ai.config.item.makeLonger.description': "Ut\xf6kar inneh\xe5llet utifr\xe5n sammanhanget du tillhandah\xe5ller",
    'fabric.editor.ai.config.item.makeLonger.title': "G\xf6r l\xe4ngre",
    'fabric.editor.ai.config.item.range.agent.description': 'Beskrivning saknas',
    'fabric.editor.ai.config.item.range.agent.prompt.hint': "Be agenten att skriva n\xe5got eller v\xe4lj nedan",
    'fabric.editor.ai.config.item.rephrase.description': "Skapar ett f\xf6rslag p\xe5 hur dina meningar kan omformuleras",
    'fabric.editor.ai.config.item.rephrase.title': 'Omformulera',
    'fabric.editor.ai.config.item.shorten.description': "Kortar ner inneh\xe5llet f\xf6r att g\xf6ra det mer koncist",
    'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': "G\xf6r kortare",
    'fabric.editor.ai.config.item.shorten.title': "G\xf6r kortare",
    'fabric.editor.ai.config.item.suggest.description': "F\xf6resl\xe5r en rubrik f\xf6r inneh\xe5llet du tillhandah\xe5ller",
    'fabric.editor.ai.config.item.suggest.title': "F\xf6resl\xe5 en titel",
    'fabric.editor.ai.config.item.summarize.description': 'Skapar en sammanfattning av texten du arbetar med och markerar viktiga punkter',
    'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Sammanfatta text',
    'fabric.editor.ai.config.item.summarize.title': 'Sammanfatta text',
    'fabric.editor.ai.config.item.translate.czech': 'Tjeckisk',
    'fabric.editor.ai.config.item.translate.danish': 'Danska',
    'fabric.editor.ai.config.item.translate.dutch': "Holl\xe4ndska",
    'fabric.editor.ai.config.item.translate.english': 'sv-SE',
    'fabric.editor.ai.config.item.translate.finnish': 'Finska',
    'fabric.editor.ai.config.item.translate.french': 'Franska',
    'fabric.editor.ai.config.item.translate.german': 'Tyska',
    'fabric.editor.ai.config.item.translate.hungarian': 'Ungerska',
    'fabric.editor.ai.config.item.translate.italian': 'Italienska',
    'fabric.editor.ai.config.item.translate.japanese': 'Japanska',
    'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': "\xd6vers\xe4tt",
    'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': "\xd6vers\xe4tt till\xa0...",
    'fabric.editor.ai.config.item.translate.norwegian': 'Norska',
    'fabric.editor.ai.config.item.translate.russian': 'Ryska',
    'fabric.editor.ai.config.item.translate.spanish': 'Spanska',
    'fabric.editor.ai.config.item.translate.swedish': 'Svenska',
    'fabric.editor.ai.config.item.translateTo.chineseSimplified.description': "\xd6vers\xe4tter texten du arbetar med till kinesiska (f\xf6renklad)",
    'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': "\xd6vers\xe4tt till kinesiska (f\xf6renklad)",
    'fabric.editor.ai.config.item.translateTo.chineseTraditional.description': "\xd6vers\xe4tter texten du arbetar med till kinesiska (traditionell)",
    'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': "\xd6vers\xe4tt till kinesiska (traditionell)",
    'fabric.editor.ai.config.item.translateTo.czech.description': "\xd6vers\xe4tter texten du arbetar med till tjeckiska",
    'fabric.editor.ai.config.item.translateTo.czech.title': "\xd6vers\xe4tt till tjeckiska",
    'fabric.editor.ai.config.item.translateTo.danish.description': "\xd6vers\xe4tter texten du arbetar med till danska",
    'fabric.editor.ai.config.item.translateTo.danish.title': "\xd6vers\xe4tt till danska",
    'fabric.editor.ai.config.item.translateTo.dutch.description': "\xd6vers\xe4tter texten du arbetar med till nederl\xe4ndska",
    'fabric.editor.ai.config.item.translateTo.dutch.title': "\xd6vers\xe4tt till nederl\xe4ndska",
    'fabric.editor.ai.config.item.translateTo.english.description': "\xd6vers\xe4tter texten du arbetar med till engelska",
    'fabric.editor.ai.config.item.translateTo.english.title': "\xd6vers\xe4tt till engelska",
    'fabric.editor.ai.config.item.translateTo.finnish.description': "\xd6vers\xe4tter texten du arbetar med till finska",
    'fabric.editor.ai.config.item.translateTo.finnish.title': "\xd6vers\xe4tt till finska",
    'fabric.editor.ai.config.item.translateTo.french.description': "\xd6vers\xe4tter texten du arbetar med till franska",
    'fabric.editor.ai.config.item.translateTo.french.title': "\xd6vers\xe4tt till franska",
    'fabric.editor.ai.config.item.translateTo.german.description': "\xd6vers\xe4tter texten du arbetar med till tyska",
    'fabric.editor.ai.config.item.translateTo.german.title': "\xd6vers\xe4tt till tyska",
    'fabric.editor.ai.config.item.translateTo.hungarian.description': "\xd6vers\xe4tter texten du arbetar med till ungerska",
    'fabric.editor.ai.config.item.translateTo.hungarian.title': "\xd6vers\xe4tt till ungerska",
    'fabric.editor.ai.config.item.translateTo.italian.description': "\xd6vers\xe4tter texten du arbetar med till italienska",
    'fabric.editor.ai.config.item.translateTo.italian.title': "\xd6vers\xe4tt till italienska",
    'fabric.editor.ai.config.item.translateTo.japanese.description': "\xd6vers\xe4tter texten du arbetar med till japanska",
    'fabric.editor.ai.config.item.translateTo.japanese.title': "\xd6vers\xe4tt till japanska",
    'fabric.editor.ai.config.item.translateTo.korean.description': "\xd6vers\xe4tter texten du arbetar med till koreanska",
    'fabric.editor.ai.config.item.translateTo.korean.title': "\xd6vers\xe4tt till koreanska",
    'fabric.editor.ai.config.item.translateTo.norwegian.description': "\xd6vers\xe4tter texten du arbetar med till norska",
    'fabric.editor.ai.config.item.translateTo.norwegian.title': "\xd6vers\xe4tt till norska",
    'fabric.editor.ai.config.item.translateTo.polish.description': "\xd6vers\xe4tter texten du arbetar med till polska",
    'fabric.editor.ai.config.item.translateTo.polish.title': "\xd6vers\xe4tt till polska",
    'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description': "\xd6vers\xe4tter texten du arbetar med till portugisiska (brasilianska)",
    'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': "\xd6vers\xe4tt till portugisiska (brasilianska)",
    'fabric.editor.ai.config.item.translateTo.russian.description': "\xd6vers\xe4tter texten du arbetar med till ryska",
    'fabric.editor.ai.config.item.translateTo.russian.title': "\xd6vers\xe4tt till ryska",
    'fabric.editor.ai.config.item.translateTo.spanish.description': "\xd6vers\xe4tter texten du arbetar med till spanska",
    'fabric.editor.ai.config.item.translateTo.spanish.title': "\xd6vers\xe4tt till spanska",
    'fabric.editor.ai.config.item.translateTo.swedish.description': "\xd6vers\xe4tter texten du arbetar med till svenska",
    'fabric.editor.ai.config.item.translateTo.swedish.title': "\xd6vers\xe4tt till svenska",
    'fabric.editor.ai.config.item.translateTo.thai.description': "\xd6vers\xe4tter texten du arbetar med till thail\xe4ndska",
    'fabric.editor.ai.config.item.translateTo.thai.title': "\xd6vers\xe4tt till thail\xe4ndska",
    'fabric.editor.ai.config.item.translateTo.turkish.description': "\xd6vers\xe4tter texten du arbetar med till turkiska",
    'fabric.editor.ai.config.item.translateTo.turkish.title': "\xd6vers\xe4tt till turkiska",
    'fabric.editor.ai.config.item.translateTo.ukrainian.description': "\xd6vers\xe4tter texten du arbetar med till ukrainska",
    'fabric.editor.ai.config.item.translateTo.ukrainian.title': "\xd6vers\xe4tt till ukrainska",
    'fabric.editor.ai.config.item.translateTo.vietnamese.description': "\xd6vers\xe4tter texten du arbetar med till vietnamesiska",
    'fabric.editor.ai.config.item.translateTo.vietnamese.title': "\xd6vers\xe4tt till vietnamesiska",
    'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': "\xc4ndra ton",
    'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Skriv om',
    'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': "\xd6vers\xe4tt",
    'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Sidrubrik',
    'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Sida',
    'fabric.editor.ai.experience-application.documentInsertError': "Vi har problem med att infoga svaret. St\xe4ng dialogrutan och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage': "Vi kan inte generera f\xf6rhandsvisningen. St\xe4ng dialogrutan och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience-application.rateLimitEnforced': "Vi har f\xe5tt f\xf6r m\xe5nga f\xf6rfr\xe5gningar om Atlassian Intelligence (AI) den senaste tiden. F\xf6rs\xf6k igen om n\xe5gra minuter eller l\xe4s om <link>\xf6verdriven anv\xe4ndning av AI</link>.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "Det gick inte att f\xe5 ett svar. Din uppmaning eller ditt svar \xf6verskred gr\xe4nsen f\xf6r denna f\xf6rfr\xe5gan. St\xe4ng dialogrutan och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience-application.unhandledErrorMessage': "Vi har problem. St\xe4ng dialogrutan och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience.apiError': "Vi kunde inte f\xe5 ett svar, f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience.aupViolationMessage': "Din uppmaning eller ditt inneh\xe5ll kanske inte f\xf6ljer v\xe5r policy f\xf6r godtagbar anv\xe4ndning. Granska b\xe5da och h\xe4nvisa till v\xe5r <link>policy f\xf6r godtagbar anv\xe4ndning</link> om det beh\xf6vs. Om problemet kvarst\xe5r kan du \xf6verv\xe4ga att prova en annan uppmaning eller ett annat inneh\xe5ll.",
    'fabric.editor.ai.experience.browseMore.agents': "Bl\xe4ddra bland agenter",
    'fabric.editor.ai.experience.discardMessagePrompt': 'Vill du kassera din uppmaning?',
    'fabric.editor.ai.experience.discardMessageResponse': 'Vill du kassera ditt svar?',
    'fabric.editor.ai.experience.elevateDisabledGenetateError': "Fri generering \xe4r inaktiverad i Elevate just nu.",
    'fabric.editor.ai.experience.engagementBannerLinksText': "\uD83D\uDE80 Nu kan du klistra in l\xe4nkar \uD83D\uDD17 till Jira- och Confluence-inneh\xe5ll i dina uppmaningar.",
    'fabric.editor.ai.experience.footerRightText.agents': 'Drivs av Rovo',
    'fabric.editor.ai.experience.hipaaContentError': "Atlassian Intelligence kunde inte behandla din f\xf6rfr\xe5gan eftersom inneh\xe5llet inneh\xe5ller l\xe4nkar till HIPAA-begr\xe4nsat inneh\xe5ll. Ta bort l\xe4nkarna och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience.inputTooShortError': "Inneh\xe5llet \xe4r f\xf6r kort f\xf6r att sammanfatta. L\xe4gg till mer och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.experience.internalServerError': "Atlassian Intelligence (AI) svarar inte. F\xf6rs\xf6k igen senare eller <link>kontrollera status f\xf6r AI</link>.",
    'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
    'fabric.editor.ai.experience.loadingTitle': 'Genererar',
    'fabric.editor.ai.experience.messageTemplateAnalysingQuery': "Analyserar: granskar din fr\xe5ga.",
    'fabric.editor.ai.experience.messageTemplateContentSearch': "S\xf6ker: v\xe4nta ett \xf6gonblick medan vi s\xf6ker efter information.",
    'fabric.editor.ai.experience.messageTemplateNextBestTask': "S\xf6ker: v\xe4nta ett \xf6gonblick, vi s\xf6ker i Jira.",
    'fabric.editor.ai.experience.messageTemplatePageHydration': "S\xf6ker: v\xe4nta ett \xf6gonblick med vi s\xf6ker p\xe5 sidan.",
    'fabric.editor.ai.experience.noResultsSuggestion': 'Inga resultat',
    'fabric.editor.ai.experience.responseTooSimilarMessage': "Atlassian Intelligence har inga f\xf6rslag just nu. Prova g\xe4rna en annan uppmaning eller ett annat inneh\xe5ll.",
    'fabric.editor.ai.experience.showMoreButton': 'Visa mer',
    'fabric.editor.ai.experience.suggestionGroupHeading.actions': "\xc5tg\xe4rder",
    'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenter',
    'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': "Kunskapsk\xe4lla",
    'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo-agenter',
    'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo-agenter ({numberOfAgents})',
    'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': "Anv\xe4nd en Rovo-agent ({numberOfAgents})",
    'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': "Anv\xe4nd allm\xe4n kunskap",
    'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': "Anv\xe4nd kunskap fr\xe5n din organisation",
    'fabric.editor.ai.proactive.error.markdownErrorMessage': "Vi kan inte generera f\xf6rhandsvisningen. St\xe4ng dialogrutan och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.proactive.error.unhandledErrorMessage': "Vi har problem. St\xe4ng dialogrutan och f\xf6rs\xf6k igen.",
    'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Infoga nedan',
    'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': "Ers\xe4tt",
    'fabric.editor.ai.screens.preview.convoAIBeta': "F\xf6rfr\xe5gningar om inneh\xe5llsgenerering som refererar till webbadresser \xe4r i betastadiet.",
    'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': "Markera en term, akronym eller f\xf6rkortning",
    'fabric.editor.ai.selectionToolbar.define.title': 'Definiera',
    'fabric.editor.ai.toolbar.askAI.title': "Fr\xe5ga Atlassian Intelligence",
    'fabric.editor.ai.toolbar.improveWriting.title': "F\xf6rb\xe4ttra skrivande",
    'fabric.editor.ai.toolbar.improveWriting.tooltip': "S\xe4g \xe5t Atlassian Intelligence att f\xf6rb\xe4ttra en vald text",
    'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
    'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
    'fabric.editor.ai.toolbar.tryAI.title': 'Prova AI',
    'fabric.editor.ai.toolbar.tryAI.tooltip': "\xd6ppna Atlassian Intelligence",
    'fabric.editor.alignCenter': 'Centrera',
    'fabric.editor.alignImageCenter': 'Centrera',
    'fabric.editor.alignImageLeft': "V\xe4nsterjustera",
    'fabric.editor.alignImageRight': "H\xf6gerjustera",
    'fabric.editor.alignLeft': "V\xe4nsterjustera",
    'fabric.editor.alignRight': "H\xf6gerjustera",
    'fabric.editor.alignTableCenter': 'Centrera',
    'fabric.editor.alignTableLeft': "V\xe4nsterjustera",
    'fabric.editor.alignment': 'Textjustering',
    'fabric.editor.altText': 'Alt-text',
    'fabric.editor.alttext.validation': 'Ta bort eventuella specialtecken i alternativ text.',
    'fabric.editor.annotationToolbar': "Verktygsf\xe4lt f\xf6r kommentarer",
    'fabric.editor.backLink': "G\xe5 tillbaka",
    'fabric.editor.backgroundColor': "Bakgrundsf\xe4rg",
    'fabric.editor.blockCardUnavailable': "Inlinel\xe4nken \xe4r inuti {node} och det g\xe5r inte att byta dess vy",
    'fabric.editor.blockControlDelete': 'Radera',
    'fabric.editor.blockControlDragHandleMove': "Dra f\xf6r att flytta",
    'fabric.editor.blockControlDragHandleRearrange': "Dra f\xf6r att ordna om",
    'fabric.editor.blockControlInsert': 'Infoga',
    'fabric.editor.blockControlMoveDown': 'Flytta ner',
    'fabric.editor.blockControlMoveLeft': "Flytta \xe5t v\xe4nster",
    'fabric.editor.blockControlMoveRight': "Flytta \xe5t h\xf6ger",
    'fabric.editor.blockControlMoveUp': 'Flytta upp',
    'fabric.editor.blockControlMovedDown': "Inneh\xe5llet har flyttats ner",
    'fabric.editor.blockControlMovedUp': "Inneh\xe5llet har flyttats upp",
    'fabric.editor.blockDescription': "Visa mer information om en l\xe4nk, inklusive en sammanfattning och \xe5tg\xe4rder",
    'fabric.editor.blockTitle': 'Kort',
    'fabric.editor.blockquote': 'ett citattecken',
    'fabric.editor.blockquote.description': 'Infoga citat',
    'fabric.editor.blockquote2': 'Citera',
    'fabric.editor.bold': 'Fet',
    'fabric.editor.breakoutFullWidthLabel': 'Full bredd',
    'fabric.editor.breakoutWideWidthLabel': 'Bred',
    'fabric.editor.bug': 'Bugg',
    'fabric.editor.canNotSortTable': "\u26A0\uFE0F Du kan inte sortera en panelvy med sammanslagna celler",
    'fabric.editor.cancelButton': 'Avbryt',
    'fabric.editor.captionPlaceholder': "L\xe4gg till en bildtext",
    'fabric.editor.captionPlaceholderWithDoubleClickPrompt': "L\xe4gg till en bildtext \u2013 dubbelklicka f\xf6r att f\xf6rhandsgranska",
    'fabric.editor.cardFloatingControls': 'Kortalternativ',
    'fabric.editor.cellBackground': 'Cellbakgrund',
    'fabric.editor.cellOptions': 'Cellalternativ',
    'fabric.editor.checkUncheckActionItem': "V\xe4xla \xe5tg\xe4rdsobjekt",
    'fabric.editor.clearAltTextEdit': 'Rensa alternativ text',
    'fabric.editor.clearCells': '{0, plural, one {Rensa cell} other {Rensa celler}}',
    'fabric.editor.clearFormatting': 'Ta bort formatering',
    'fabric.editor.clearLink': "Rensa l\xe4nk",
    'fabric.editor.clearLinkText': 'Rensa text',
    'fabric.editor.closeAltTextEdit': 'Tillbaka',
    'fabric.editor.closeFindReplaceDialog': "St\xe4ng",
    'fabric.editor.closeHelpDialog': "St\xe4ng hj\xe4lpdialog",
    'fabric.editor.code': 'Kod',
    'fabric.editor.code.on': "{textFormattingOff}, kod p\xe5",
    'fabric.editor.codeBidiWarningLabel': "Dubbelriktade tecken \xe4ndrar \xe5tergivningsordningen f\xf6r text. Detta kan anv\xe4ndas f\xf6r att d\xf6lja skadlig kod.",
    'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Kopierad!',
    'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopiera som text',
    'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Inaktivera brytning',
    'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Aktivera brytning',
    'fabric.editor.codeblock': 'Kodstycke',
    'fabric.editor.codeblock.description': 'Visa kod med syntaxmarkering',
    'fabric.editor.collapseNode': "komprimera inneh\xe5ll",
    'fabric.editor.collapseTable': "D\xf6lj tabell",
    'fabric.editor.colorPicker.menuLabel': "Meny f\xf6r f\xe4rgv\xe4ljare",
    'fabric.editor.columnDragHandle': 'Kolumnalternativ',
    'fabric.editor.columnMovedLeft': "Kolumnen flyttades \xe5t v\xe4nster till {index} av {total}",
    'fabric.editor.columnMovedRight': "Kolumnen flyttades \xe5t h\xf6ger till {index} av {total}",
    'fabric.editor.columnSelected': 'Kolumn {index} av {total} markerad',
    'fabric.editor.columns': 'Layouter',
    'fabric.editor.columns.advanced.layout.description': '{numberOfColumns, plural, one {Infoga {numberOfColumns} likadan kolumn} other {Infoga {numberOfColumns} likadana kolumner}}',
    'fabric.editor.columns.advanced.layout.single.description': 'Infoga layout med en kolumn',
    'fabric.editor.columns.description': 'Ge din sida struktur med sektioner',
    'fabric.editor.columnsAreInserted': '{count, plural, one {En kolumn har infogats} other {{count} kolumner har infogats}}',
    'fabric.editor.columnsAreRemoved': '{count, plural, one {Kolumnen har tagits bort} other {{count} kolumner har tagits bort}}',
    'fabric.editor.configFailedToLoad': "Fel vid inl\xe4sning",
    'fabric.editor.configPanel.cancel': 'Avbryt',
    'fabric.editor.configPanel.close': "St\xe4ng",
    'fabric.editor.configPanel.customSelect.createOption': 'Skapa',
    'fabric.editor.configPanel.dateRange.custom.from': "Fr\xe5n",
    'fabric.editor.configPanel.dateRange.custom.to': 'Till',
    'fabric.editor.configPanel.dateRange.grouping.collapse': "D\xf6lj",
    'fabric.editor.configPanel.dateRange.grouping.expand': 'Expandera',
    'fabric.editor.configPanel.dateRange.option.custom': 'Anpassat',
    'fabric.editor.configPanel.documentation': 'Dokumentation',
    'fabric.editor.configPanel.errorBoundary.note': "Vi har meddelat teamet. Du kan fortfarande redigera och publicera sidan eller kontrollera felkonsolen f\xf6r mer information.",
    'fabric.editor.configPanel.errorBoundary.title': "N\xe5got gick fel.",
    'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Kan inte kombinera isMultiple med stilen radio',
    'fabric.editor.configPanel.formType.addField': "L\xe4gg till f\xe4lt",
    'fabric.editor.configPanel.formType.removeField': "Ta bort f\xe4lt",
    'fabric.editor.configPanel.help': "Beh\xf6ver du hj\xe4lp?",
    'fabric.editor.configPanel.invalid': "Ogiltigt f\xe4lt",
    'fabric.editor.configPanel.required': "Obligatoriskt f\xe4lt",
    'fabric.editor.configPanel.submit': 'Skicka in',
    'fabric.editor.copiedToClipboard': 'Kopierad!',
    'fabric.editor.copyToClipboard': 'Kopiera',
    'fabric.editor.cornerControl': 'Markera tabellen',
    'fabric.editor.createComment': 'Kommentera',
    'fabric.editor.createCommentDisabled': "Du kan bara kommentera text, rubriker, emojis, datum, omn\xe4mnanden, l\xe4nkar och statusar.",
    'fabric.editor.createCommentInvalid': "Du kan bara kommentera p\xe5 text och rubriker",
    'fabric.editor.createCommentOnInlineNodeSpotlight.action': "Jag f\xf6rst\xe5r",
    'fabric.editor.createCommentOnInlineNodeSpotlight.body': "Nu kan nu l\xe4mna kommentarer i infogade delar som l\xe4nkar, datum, statusar och omn\xe4mnanden.",
    'fabric.editor.customPanel': 'Anpassad panel',
    'fabric.editor.customPanel.description': "L\xe4gg till en anteckning med en emoji och en f\xe4rgad bakgrund",
    'fabric.editor.datasource.assetsObjects.description': "Infoga objekt fr\xe5n Tillg\xe5ngar i Jira Service Management med s\xf6kning och filtrering",
    'fabric.editor.datasource.assetsObjectsGeneralAvailability': "Tillg\xe5ngar",
    'fabric.editor.datasource.confluenceSearch': 'Infoga Confluence-lista',
    'fabric.editor.datasource.confluenceSearch.description': "Infoga lista \xf6ver s\xf6kresultat fr\xe5n Confluence med f\xf6rb\xe4ttrad s\xf6kning, filtrering och konfiguration.",
    'fabric.editor.datasource.jiraIssue': "Jira-\xe4renden",
    'fabric.editor.datasource.jiraIssue.description': "Infoga Jira-\xe4renden fr\xe5n Jira Cloud med f\xf6rb\xe4ttrad s\xf6kning, filtrering och konfiguration.",
    'fabric.editor.datasource.jiraIssue.description.issue-term-refresh': "Infoga Jira-arbetsobjekt fr\xe5n Jira Cloud med f\xf6rb\xe4ttrad s\xf6kning, filtrering och konfiguration.",
    'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira-arbetsuppgifter',
    'fabric.editor.datasourceAppearanceTitle': 'Lista',
    'fabric.editor.datasourceTitle': "Redigera s\xf6kfr\xe5ga",
    'fabric.editor.date': 'Datum',
    'fabric.editor.date.description': "L\xe4gg till ett datum med en kalender",
    'fabric.editor.datePickerOpenedAlert': "Popup-f\xf6nster f\xf6r datumv\xe4ljare \xf6ppnades, tryck p\xe5 Tab f\xf6r att komma \xe5t datumv\xe4ljaren",
    'fabric.editor.decision': 'Beslut',
    'fabric.editor.decision.description': "F\xe5nga beslut s\xe5 att de \xe4r enklare att sp\xe5ra",
    'fabric.editor.decisionPlaceholder': "L\xe4gg till ett beslut ...",
    'fabric.editor.decreaseSize': 'Minska tabell- eller mediastorlek',
    'fabric.editor.defaultAltText': 'Dokument',
    'fabric.editor.delete': 'Radera',
    'fabric.editor.description': 'Beskrivning',
    'fabric.editor.displayBlock': 'Visa kort',
    'fabric.editor.displayEmbed': "Visa inb\xe4ddad",
    'fabric.editor.displayInline': 'Visa inline',
    'fabric.editor.displayLink': 'Visa som text',
    'fabric.editor.displayOptionUnavailableInParentNode': "Det h\xe4r visningsalternativet \xe4r inte tillg\xe4ngligt inuti {node}",
    'fabric.editor.displayText': 'Text att visa',
    'fabric.editor.distributeColumns': "F\xf6rdela kolumner",
    'fabric.editor.dropPlaceholderLabel': 'Dokument',
    'fabric.editor.ecombedDescription': "Visa en interaktiv f\xf6rhandsvisning av en l\xe4nk",
    'fabric.editor.edit': 'Redigera',
    'fabric.editor.edit.datasource': "Redigera s\xf6kfr\xe5ga",
    'fabric.editor.edit.searchInput': "L\xe4gg till en l\xe4nk",
    'fabric.editor.editAccessTitle': "Du beh\xf6ver redigerings\xe5tkomst",
    'fabric.editor.editAltText': 'Redigera alternativ text',
    'fabric.editor.editDatasourceStandalone': 'Redigera',
    'fabric.editor.editDatasourceStandaloneTooltip': "Redigera s\xf6kfr\xe5ga",
    'fabric.editor.editDateText': 'Redigeringsdatum',
    'fabric.editor.editDropdownEditDatasourceTitle': "Redigera s\xf6kfr\xe5ga",
    'fabric.editor.editDropdownEditLinkTitle': "Redigera l\xe4nk",
    'fabric.editor.editDropdownExpandIconLabel': 'Expandera rullgardinsmeny',
    'fabric.editor.editDropdownTriggerTitle': 'Redigera',
    'fabric.editor.editLink': "Redigera l\xe4nk",
    'fabric.editor.editMode.inviteToEditButton.title': 'Bjud in att redigera',
    'fabric.editor.editStatusColor': "Redigera statusf\xe4rg",
    'fabric.editor.editStatusText': 'Redigera status',
    'fabric.editor.editableContentLabel': "Inneh\xe5ll som kan redigeras",
    'fabric.editor.editorHelp': "Editor-hj\xe4lp",
    'fabric.editor.editors': 'Redigerare',
    'fabric.editor.elementBrowser.help': "Hj\xe4lp",
    'fabric.editor.elementInsertSidePanel.title': 'Infoga',
    'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
    'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
    'fabric.editor.elementbrowser.categorylist.category-all': 'Alla',
    'fabric.editor.elementbrowser.categorylist.category-communication': 'Kommunikation',
    'fabric.editor.elementbrowser.categorylist.category-confluence-content': "Confluence-inneh\xe5ll",
    'fabric.editor.elementbrowser.categorylist.category-development': 'Utveckling',
    'fabric.editor.elementbrowser.categorylist.category-external-content': "Externt inneh\xe5ll",
    'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatering',
    'fabric.editor.elementbrowser.categorylist.category-media': 'Media',
    'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigering',
    'fabric.editor.elementbrowser.categorylist.category-reporting': 'Rapportering',
    'fabric.editor.elementbrowser.categorylist.category-visuals': 'Grafik och bilder',
    'fabric.editor.elementbrowser.search.empty-state.heading': "Ingenting matchar din s\xf6kning",
    'fabric.editor.elementbrowser.search.empty-state.sub-heading': "Prova att s\xf6ka med en annan term eller uppt\xe4ck nya appar f\xf6r Atlassian-produkter.",
    'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Utforska Atlassian Marketplace',
    'fabric.editor.elementbrowser.searchbar.assistive.text.default': "{count, plural, =0 {Ingenting matchar din s\xf6kning.} one {{count} f\xf6rslag tillg\xe4ngligt som standard.} other {{count} f\xf6rslag tillg\xe4ngliga som standard.}}",
    'fabric.editor.elementbrowser.searchbar.assistive.text.result': "{count, plural, =0 {Ingenting matchar din s\xf6kning.} one {{count} f\xf6rslag tillg\xe4ngliga f\xf6r skriven text.} other {{count} f\xf6rslag tillg\xe4ngliga f\xf6r skriven text.}}",
    'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Retur',
    'fabric.editor.elementbrowser.searchbar.placeholder': "S\xf6k",
    'fabric.editor.elementbrowser.sidebar.heading': "Bl\xe4ddra",
    'fabric.editor.embedTitle': "B\xe4dda in",
    'fabric.editor.emoji': 'Emoji',
    'fabric.editor.emoji.description': "Anv\xe4nd emojis f\xf6r att uttrycka id\xe9er \uD83C\uDF89 och k\xe4nslor \uD83D\uDE04",
    'fabric.editor.emptyLink': "Ange en l\xe4nk.",
    'fabric.editor.emptySearchResults': 'Vi hittade inga resultat.',
    'fabric.editor.emptySearchResultsSuggestion': "V\xe4lj {buttonName} om du vill bl\xe4ddra bland infogningar.",
    'fabric.editor.epic': 'Epic',
    'fabric.editor.error': 'Fel',
    'fabric.editor.errorPanel': 'Felpanel',
    'fabric.editor.errorPanel.description': "Meddela om fel i en f\xe4rgad panel",
    'fabric.editor.expand': 'Expandera',
    'fabric.editor.expand.description': 'Infoga expandering',
    'fabric.editor.expandAriaLabel': 'Ge expanderingen en titel',
    'fabric.editor.expandDefaultTitle': "Klicka h\xe4r f\xf6r att expandera ...",
    'fabric.editor.expandNode': "Expandera inneh\xe5ll",
    'fabric.editor.expandPlaceholder': "Ge expanderingen en titel\xa0...",
    'fabric.editor.extension.confirmDeleteLinkedModalMessage': "Om du raderar {nodeName} bryts allt som \xe4r kopplat till den.",
    'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Raderar',
    'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Radera',
    'fabric.editor.extension.deleteElementTitle': 'Radera element',
    'fabric.editor.extension.sourceNoTitledName': 'detta element',
    'fabric.editor.extensions.config-panel.save-indicator': "Alla \xe4ndringar sparas alltid automatiskt",
    'fabric.editor.externalExtensionsHeading': 'Appar',
    'fabric.editor.externalMediaFile': 'Extern mediefil',
    'fabric.editor.failed_to_upload': 'Uppladdning misslyckades',
    'fabric.editor.feedbackDialog': 'Ge feedback',
    'fabric.editor.feedbackDialog.description': "Ber\xe4tta f\xf6r oss om din upplevelse av den nya redigeraren",
    'fabric.editor.find': 'Hitta',
    'fabric.editor.findNext': "Hitta n\xe4sta",
    'fabric.editor.findPrevious': "Hitta f\xf6reg\xe5ende",
    'fabric.editor.findReplaceToolbarButton': "S\xf6k och ers\xe4tt",
    'fabric.editor.fiveColumns': 'Layout med fem kolumner',
    'fabric.editor.floatingToolbar.confirmModalCancel': 'Avbryt',
    'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': "Radera \xe4ven anslutna element",
    'fabric.editor.floatingToolbar.confirmModalConnectedUnit': '{amount, plural, =0 {{name}} one {{name} (+1 anslutet element)} other {{name} (+{amount,number} anslutna element)}}',
    'fabric.editor.floatingToolbar.confirmModalHeading': "\xc4r du s\xe4ker?",
    'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
    'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': "Sv\xe4vande verktygsf\xe4lt har \xf6ppnats",
    'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': "Sv\xe4vande verktygsf\xe4lt",
    'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Layout-alternativ',
    'fabric.editor.floatingToolbar.scrollLeft': "Bl\xe4ddra \xe5t v\xe4nster",
    'fabric.editor.floatingToolbar.scrollRight': "Bl\xe4ddra \xe5t h\xf6ger",
    'fabric.editor.focusTableResizeHandle': "Handtag f\xf6r att \xe4ndra storlek p\xe5 fokustabell",
    'fabric.editor.fourColumns': 'Layout med fyra kolumner',
    'fabric.editor.headerColumn': 'Rubrikkolumn',
    'fabric.editor.headerRow': 'Rubrikrad',
    'fabric.editor.heading1': 'Rubrik 1',
    'fabric.editor.heading1Description': "Anv\xe4nd f\xf6r rubrik p\xe5 \xf6versta niv\xe5n",
    'fabric.editor.heading2': 'Rubrik 2',
    'fabric.editor.heading2Description': "Anv\xe4nd f\xf6r viktiga avsnitt",
    'fabric.editor.heading3': 'Rubrik 3',
    'fabric.editor.heading3Description': "Anv\xe4nd f\xf6r underavsnitt och grupprubriker",
    'fabric.editor.heading4': 'Rubrik 4',
    'fabric.editor.heading4Description': "Anv\xe4nd f\xf6r rubriker l\xe4ngre ner",
    'fabric.editor.heading5': 'Rubrik 5',
    'fabric.editor.heading5Description': "Anv\xe4nd f\xf6r att gruppera listobjekt",
    'fabric.editor.heading6': 'Rubrik 6',
    'fabric.editor.heading6Description': "Anv\xe4nd f\xf6r rubriker p\xe5 l\xe5g niv\xe5",
    'fabric.editor.headingLink.ascOrderLabel': "Sortera kolumn \xd6 till A",
    'fabric.editor.headingLink.descOrderLabel': 'Rensa sortering',
    'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blogg',
    'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bugg',
    'fabric.editor.headingLink.hyperlinkIconIssueLabel': "\xc4rende",
    'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Arbetsuppgift',
    'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Sida',
    'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
    'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Uppgift',
    'fabric.editor.headingLink.invalidLabel': "\u26A0\uFE0F Du kan inte sortera en panelvy med sammanslagna celler",
    'fabric.editor.headingLink.noOrderLabel': "Sortera kolumn A till \xd6",
    'fabric.editor.help': "Hj\xe4lp",
    'fabric.editor.help.description': "Bl\xe4ddra bland alla tangentbordsgenv\xe4gar och Markdown-alternativ",
    'fabric.editor.helpDialogTips': "Tryck p\xe5 {keyMap} f\xf6r att n\xe4r som helst \xf6ppna den h\xe4r dialogrutan",
    'fabric.editor.highlight': "Markeringsf\xe4rg",
    'fabric.editor.highlightColor': "V\xe4xla palett f\xf6r markeringsf\xe4rg",
    'fabric.editor.highlightFloatingToolbar': 'Markering',
    'fabric.editor.horizontalRule': "Avgr\xe4nsare",
    'fabric.editor.horizontalRule.description': "Separera inneh\xe5ll med en horisontell linje",
    'fabric.editor.hyperlink.linkVisibleLabel': "Klistra in eller s\xf6k efter en l\xe4nk",
    'fabric.editor.hyperlink.searchLinkAriaDescription': "F\xf6rslag visas nedan n\xe4r du skriver i f\xe4ltet",
    'fabric.editor.hyperlink.searchLinkResults': '{count, plural, =0 {inga resultat hittades} one {{count,number} resultat hittades} other {{count,number} resultat hittades}}',
    'fabric.editor.hyperlink.textVisibleLabel': 'Visningstext (valfritt)',
    'fabric.editor.hyperlinkToolbarPlaceholder': "Klistra in eller s\xf6k efter en l\xe4nk",
    'fabric.editor.image': 'Bild',
    'fabric.editor.image.fullWidthLabel': 'Full bredd',
    'fabric.editor.imageBorderBold': 'Fetstil',
    'fabric.editor.imageBorderColor': "F\xe4rg",
    'fabric.editor.imageBorderColor.dropdownAriaLabel': "Listruta f\xf6r bildkantsalternativ f\xf6r f\xe4rg",
    'fabric.editor.imageBorderMedium': 'Medium',
    'fabric.editor.imageBorderOptions': 'Kantalternativ',
    'fabric.editor.imageBorderSize': 'Storlek',
    'fabric.editor.imageBorderSize.dropdownAriaLabel': "Listruta f\xf6r bildkantsalternativ f\xf6r storlek",
    'fabric.editor.imageBorderSubtle': 'Diskret',
    'fabric.editor.improvement': "F\xf6rb\xe4ttring",
    'fabric.editor.increaseSize': "\xd6ka tabell- eller mediastorlek",
    'fabric.editor.indent': 'Indrag',
    'fabric.editor.info': 'Info',
    'fabric.editor.infoPanel': 'Informationspanel',
    'fabric.editor.infoPanel.description': "Markera information med en f\xe4rgad panel",
    'fabric.editor.inlineConfigureLink': "Konfigurera l\xe4nk",
    'fabric.editor.inlineDescription': "Visa l\xe4nk som infogad text",
    'fabric.editor.inlineGoToLink': "G\xe5 till l\xe4nk",
    'fabric.editor.inlineOverlay': 'Konfigurera',
    'fabric.editor.inlineTitle': 'Inline',
    'fabric.editor.inputQueryAssistiveTxt': "N\xe4r autokompletteringsresultat \xe4r tillg\xe4ngliga anv\xe4nder du upp- och nedpilarna f\xf6r att granska och Enter f\xf6r att v\xe4lja. Anv\xe4ndare med peksk\xe4rm kan utforska genom att r\xf6ra vid sk\xe4rmen eller svepa p\xe5 den.",
    'fabric.editor.insertColumn': "Infoga kolumn till h\xf6ger",
    'fabric.editor.insertColumnDrag': 'Infoga kolumn',
    'fabric.editor.insertMenu': 'Infoga element',
    'fabric.editor.insertRightRail.close': "St\xe4ng",
    'fabric.editor.insertRightRail.title': 'Infoga',
    'fabric.editor.insertRow': "Infoga rad nedanf\xf6r",
    'fabric.editor.insertRowDrag': 'Infoga rad',
    'fabric.editor.insertTableColumn': 'Infoga tabellkolumn',
    'fabric.editor.insertTableRow': 'Infoga tabellrad',
    'fabric.editor.invalidDateError': 'Ange ett giltigt datum',
    'fabric.editor.invalidLink': "Ange en giltig l\xe4nk.",
    'fabric.editor.inviteItem.title': "{userRole, select, admin {Bjud in teammedlem till {productName}} trusted {Bjud in teammedlem till {productName}} other {L\xe4gg till teammedlem i {productName}}}",
    'fabric.editor.italic': 'Kursiv',
    'fabric.editor.keyboardShortcuts': 'Kortkommandon',
    'fabric.editor.layout.columnOption': '{count, plural, one {Kolumn} other {{count} kolumner}}',
    'fabric.editor.layout.controls.placeholder': "/ f\xf6r att infoga",
    'fabric.editor.layout.placeholder': "L\xe4gg till inneh\xe5ll",
    'fabric.editor.layout.resizeLayout': "\xc4ndra storlek p\xe5 layout",
    'fabric.editor.layoutFixedWidth': 'Tillbaka till centrera',
    'fabric.editor.layoutFullWidth': "Anv\xe4nd full bredd",
    'fabric.editor.layoutStateFixedWidth': 'Centrerad',
    'fabric.editor.layoutStateFullWidth': 'Full bredd',
    'fabric.editor.layoutStateWide': 'Bred',
    'fabric.editor.layoutWide': "Anv\xe4nd bred",
    'fabric.editor.leftSidebar': "Layout med v\xe4nster sidopanel",
    'fabric.editor.link': "L\xe4nk",
    'fabric.editor.link.description': "Infoga l\xe4nk",
    'fabric.editor.linkAddress': "L\xe4nkadress",
    'fabric.editor.linkPlaceholder': "Klistra in l\xe4nk",
    'fabric.editor.lists': 'Listor',
    'fabric.editor.listsFormat': 'Listformatering',
    'fabric.editor.lockColumns': 'Fasta kolumnbredder',
    'fabric.editor.longEmptyNodePlaceholderText': 'Ange / om du vill infoga element',
    'fabric.editor.markdown': 'Markdown',
    'fabric.editor.matchCase': "Matcha skiftl\xe4ge",
    'fabric.editor.media.DefaultMediaWidthDecreased': '{newMediaWidth, plural, one {Mediabredden har minskats till {newMediaWidth,number} pixel.} other {Mediabredden har minskats till {newMediaWidth,number} pixlar.}}',
    'fabric.editor.media.DefaultMediaWidthIncreased': "{newMediaWidth, plural, one {Mediabredden har \xf6kats till {newMediaWidth,number} pixel.} other {Mediabredden har \xf6kats till {newMediaWidth,number} pixlar.}}",
    'fabric.editor.media.MediaWidthIsMin': 'Media har minskats till minsta storlek',
    'fabric.editor.media.insert.cancel': 'Avbryt',
    'fabric.editor.media.insert.fileTabTitle': 'Fil',
    'fabric.editor.media.insert.fromUrlErrorMessage': "Vi kan tyv\xe4rr inte l\xe4gga till den h\xe4r bildl\xe4nken. Ladda ner bilden och dra och sl\xe4pp den p\xe5 sidan.",
    'fabric.editor.media.insert.fromUrlWarning': "Bilden kanske inte \xe4r synlig f\xf6r andra p\xe5 grund av k\xe4llbegr\xe4nsningar. \xd6verv\xe4g att ladda upp filen ist\xe4llet.",
    'fabric.editor.media.insert.insert': 'Infoga',
    'fabric.editor.media.insert.invalidUrlErrorMessage': "Ogiltig l\xe4nk",
    'fabric.editor.media.insert.linkTabTitle': "L\xe4nk",
    'fabric.editor.media.insert.loadPreview': "L\xe4s in f\xf6rhandsgranskning",
    'fabric.editor.media.insert.localFileErrorMessage': 'Det gick inte att ladda upp filen.',
    'fabric.editor.media.insert.localFileNetworkErrorMessage': "Fel vid filuppladdning. Kontrollera fils\xf6kv\xe4gen eller n\xe4tverket.",
    'fabric.editor.media.insert.mediaAlt': "F\xf6rhandsgranskning av uppladdad bild- eller videofil",
    'fabric.editor.media.insert.mediaPickerPopupAriaLabel': "Mediev\xe4ljare",
    'fabric.editor.media.insert.pasteLinkToUpload': "Klistra in l\xe4nk f\xf6r att ladda upp",
    'fabric.editor.media.insert.upload': 'Ladda upp',
    'fabric.editor.media.pixelEntry.MediaWidthIsMax': "Media har \xf6kats till maximal storlek",
    'fabric.editor.media.pixelEntry.ResizeOption': "\xc4ndra storlek",
    'fabric.editor.media.pixelEntry.closePixelEntry': "St\xe4ng",
    'fabric.editor.media.pixelEntry.inputHeightAriaLabel': "h\xf6jding\xe5ng",
    'fabric.editor.media.pixelEntry.inputHeightTooltip': "H\xf6jd",
    'fabric.editor.media.pixelEntry.inputWidthAriaLabel': "Maxbredd {maxWidth}\xa0px",
    'fabric.editor.media.pixelEntry.inputWidthLabel': 'Bredd',
    'fabric.editor.media.pixelEntry.inputWidthTooltip': "Maxbredd {maxWidth}\xa0px",
    'fabric.editor.media.pixelEntry.migrationButtonText': 'Omvandla till pixlar',
    'fabric.editor.media.pixelEntry.migrationButtonTooltip': "Migrera fr\xe5n procent till fast pixelstorlek",
    'fabric.editor.media.pixelEntry.submitButtonText': 'Skicka in',
    'fabric.editor.media.pixelEntry.validationFailedMessage': "Validering f\xf6r bredd misslyckades",
    'fabric.editor.mediaAddLink': "L\xe4gg till l\xe4nk",
    'fabric.editor.mediaFiles': 'Bild, video eller fil',
    'fabric.editor.mediaFiles.description': "L\xe4gg till bilder och andra filer till din sida",
    'fabric.editor.mediaGroupDeleteLabel': 'radera',
    'fabric.editor.media_change_mediainline_caption_warn': 'Inline (bildtext tas bort)',
    'fabric.editor.media_change_mediainline_default': 'Inline',
    'fabric.editor.media_change_mediasingle': 'Originalstorlek',
    'fabric.editor.mention': "Omn\xe4mnande",
    'fabric.editor.mention.description': "N\xe4mn n\xe5gon f\xf6r att skicka en avisering till dem",
    'fabric.editor.mentionNode.label': "Taggade anv\xe4ndaren",
    'fabric.editor.mentionsAddLabel': "l\xe4gg till-ikon",
    'fabric.editor.mentionsIconLabel': "Omn\xe4mnande",
    'fabric.editor.mergeCells': 'Sammanfoga celler',
    'fabric.editor.moreFormatting': 'Mer formatering',
    'fabric.editor.moveColumnLeft': "{0, plural, one {Flytta kolumn \xe5t v\xe4nster} other {Flytta kolumner \xe5t v\xe4nster}}",
    'fabric.editor.moveColumnRight': "{0, plural, one {Flytta kolumn \xe5t h\xf6ger} other {Flytta kolumner \xe5t h\xf6ger}}",
    'fabric.editor.moveDownDown': "{0, plural, one {Flytta rad ned\xe5t} other {Flytta rader ned\xe5t}}",
    'fabric.editor.moveRowUp': "{0, plural, one {Flytta rad upp\xe5t} other {Flytta rader upp\xe5t}}",
    'fabric.editor.navigate.toolbar.editor': "G\xe5 till verktygsf\xe4ltet f\xf6r redigering",
    'fabric.editor.navigate.toolbar.floating': "G\xe5 till det sv\xe4vande verktygsf\xe4ltet",
    'fabric.editor.noResultsFound': 'Inga resultat',
    'fabric.editor.noSearchResults': "Inga s\xf6kresultat",
    'fabric.editor.normal': 'Normal text',
    'fabric.editor.note': 'Anteckning',
    'fabric.editor.notePanel': 'Anteckningspanel',
    'fabric.editor.notePanel.description': "L\xe4gg till en anteckning i en f\xe4rgad panel",
    'fabric.editor.numberedColumn': 'Numrerad kolumn',
    'fabric.editor.off': '{formattingType} av',
    'fabric.editor.offlineErrorFallbackDescription': "F\xf6rs\xf6k uppdatera sidan.",
    'fabric.editor.offlineErrorFallbackHeading': "N\xe5got gick fel!",
    'fabric.editor.on': "{formattingType} p\xe5",
    'fabric.editor.openCellOptions': "\xd6ppna cellalternativ",
    'fabric.editor.openLink': "\xd6ppna l\xe4nk i en ny flik",
    'fabric.editor.orderedList': 'Numrerad lista',
    'fabric.editor.orderedList.description': 'Skapa en sorterad lista',
    'fabric.editor.other': 'Annat ...',
    'fabric.editor.outdent': 'Utdrag',
    'fabric.editor.overflowMenuViewMore': 'Visa mer',
    'fabric.editor.pageActionsLabel': "Sid\xe5tg\xe4rder",
    'fabric.editor.panel': 'Panel',
    'fabric.editor.panel.backgroundColor': "Bakgrundsf\xe4rg",
    'fabric.editor.panel.custom': 'Anpassat',
    'fabric.editor.panel.emoji': "L\xe4gg till emoji",
    'fabric.editor.panel.panelsGroup': 'Paneltyper',
    'fabric.editor.pasteOptions': 'Inklistringsalternativ',
    'fabric.editor.pastePlainText': 'Klistra in oformaterad text',
    'fabric.editor.placeholderAltText': "Beskriv den h\xe4r bilden med alternativ text",
    'fabric.editor.placeholderText': "Platsh\xe5llartext",
    'fabric.editor.placeholderText.description': "Infoga en platsh\xe5llare f\xf6r text p\xe5 sidan",
    'fabric.editor.placeholderTextPlaceholder': "L\xe4gg till platsh\xe5llartext",
    'fabric.editor.plainText': "Anv\xe4nd oformaterad text",
    'fabric.editor.preferencesLink': "L\xe4nkinst\xe4llningar",
    'fabric.editor.quickInsert': 'Snabbinfoga',
    'fabric.editor.recordLoomShortTitle': 'Spela in',
    'fabric.editor.recordVideo': 'Spela in en Loom-video',
    'fabric.editor.recordVideo.description': "Spela in och dela din sk\xe4rm och dina tankar",
    'fabric.editor.redo': "G\xf6r om",
    'fabric.editor.remove': 'Ta bort',
    'fabric.editor.removeColumns': '{0, plural, one {Radera kolumn} other {Radera kolumner}}',
    'fabric.editor.removeEmoji': 'Ta bort emoji',
    'fabric.editor.removeImageBorder': 'Ta bort kanten',
    'fabric.editor.removeRows': '{0, plural, one {Radera rad} other {Radera rader}}',
    'fabric.editor.replace': "Ers\xe4tt",
    'fabric.editor.replaceAll': "Ers\xe4tt alla",
    'fabric.editor.replaceSuccess': '{numberOfMatches, plural, one {{numberOfMatches,number} matchning ersatt} other {{numberOfMatches,number} matchningar ersatta}}',
    'fabric.editor.replaceWith': "Ers\xe4tt med",
    'fabric.editor.requestToEdit': "F\xf6rfr\xe5gan om att redigera",
    'fabric.editor.requestToEditDescription': "N\xe4r du beg\xe4r \xe5tkomst f\xe5r sidans \xe4gare ett meddelande.",
    'fabric.editor.requestToEditDismiss': "Avf\xe4rda",
    'fabric.editor.resultsCount': '{selectedMatchPosition} av {totalResultsCount}',
    'fabric.editor.richText': "Anv\xe4nd RTF",
    'fabric.editor.rightSidebar': "Layout med h\xf6ger sidopanel",
    'fabric.editor.rowControl': 'Markera raden',
    'fabric.editor.rowDragHandle': 'Radalternativ',
    'fabric.editor.rowMovedDown': 'Raden flyttades ner till {index} av {total}',
    'fabric.editor.rowMovedUp': 'Raden flyttades upp till {index} av {total}',
    'fabric.editor.rowSelected': 'Rad {index} av {total} markerad',
    'fabric.editor.rowsAreInserted': '{count, plural, one {En rad har infogats} other {{count} rader har infogats}}',
    'fabric.editor.rowsAreRemoved': '{count, plural, one {Raden har tagits bort} other {{count} rader har tagits bort}}',
    'fabric.editor.saveButton': 'Spara',
    'fabric.editor.searchResults': "{itemsLength, plural, one {{itemsLength,number} s\xf6kresultat tillg\xe4ngligt. Anv\xe4nd upp\xe5t- och ned\xe5tpilarna f\xf6r att bl\xe4ddra bland alternativen. Tryck p\xe5 Enter f\xf6r att v\xe4lja ett alternativ.} other {{itemsLength,number} s\xf6kresultat tillg\xe4ngliga. Anv\xe4nd upp\xe5t- och nerpilarna f\xf6r att bl\xe4ddra bland alternativen. Tryck p\xe5 Enter f\xf6r att v\xe4lja ett alternativ.}}",
    'fabric.editor.selectColumnResize': "V\xe4lj storleks\xe4ndring av kolumn",
    'fabric.editor.selectLanguage': "V\xe4lj spr\xe5k",
    'fabric.editor.selectTableColumn': "V\xe4lj tabellkolumn",
    'fabric.editor.selectTableRow': "V\xe4lj tabellrad",
    'fabric.editor.selectionExtensionDropdownButtonLabel': "V\xe4lj app",
    'fabric.editor.settingsLinks': "G\xe5 till l\xe4nkinst\xe4llningar",
    'fabric.editor.shortEmptyNodePlaceholderText': "/ f\xf6r att infoga",
    'fabric.editor.shortcut': "Textgenv\xe4g",
    'fabric.editor.single': 'Layout med en kolumn',
    'fabric.editor.singleColumns': 'Layout med en kolumn',
    'fabric.editor.sortColumnASC': "Sortera kolumn A \u2192 \xd6",
    'fabric.editor.sortColumnDESC': "Sortera kolumn \xd6 \u2192 A",
    'fabric.editor.sortColumnDecreasing': 'Sortera fallande',
    'fabric.editor.sortColumnIncreasing': 'Sortera stigande',
    'fabric.editor.splitCell': 'Dela cell',
    'fabric.editor.status': 'Status',
    'fabric.editor.status.description': "L\xe4gg till en anpassad statusetikett",
    'fabric.editor.statusEditorLabel': 'Statusredigerare',
    'fabric.editor.statusPickerOpenedAlert': "Popup-f\xf6nster f\xf6r statusv\xe4ljare \xf6ppnades. Tryck p\xe5 Tab f\xf6r att komma \xe5t statusv\xe4ljaren",
    'fabric.editor.statusPlaceholder': 'Ange status',
    'fabric.editor.story': 'Story',
    'fabric.editor.strike': 'Genomstrykning',
    'fabric.editor.subTask': 'Underordnad uppgift',
    'fabric.editor.subscript': "Neds\xe4nkt",
    'fabric.editor.subscript.off.superscript.on': "Neds\xe4nkt text av, upph\xf6jd text p\xe5",
    'fabric.editor.success': 'Klart!',
    'fabric.editor.successPanel': "Framg\xe5ngspanel",
    'fabric.editor.successPanel.description': "L\xe4gg till ett tips i en f\xe4rgad panel",
    'fabric.editor.superscript': "Upph\xf6jd",
    'fabric.editor.superscript.off.subscript.on': "Upph\xf6jd text av, neds\xe4nkt text p\xe5",
    'fabric.editor.supportAltText': "Alternativ text \xe4r anv\xe4ndbart f\xf6r de som anv\xe4nder sk\xe4rml\xe4sare p\xe5 grund av visuella begr\xe4nsningar.",
    'fabric.editor.table': 'Tabell',
    'fabric.editor.table.description': 'Infoga en tabell',
    'fabric.editor.tableAlignmentOptions': 'Justeringsalternativ',
    'fabric.editor.tableFullWidthLabel': 'Full bredd',
    'fabric.editor.tableHeader.sorting.asc': "Stigande sortering anv\xe4nds",
    'fabric.editor.tableHeader.sorting.default': 'Sortera kolumnen',
    'fabric.editor.tableHeader.sorting.desc': "Fallande sortering anv\xe4nds",
    'fabric.editor.tableHeader.sorting.invalid': 'Du kan inte sortera en tabell med sammanslagna celler',
    'fabric.editor.tableHeader.sorting.no': "Ingen sortering anv\xe4nds p\xe5 kolumnen",
    'fabric.editor.tableOptions': 'Tabellalternativ',
    'fabric.editor.tableResizeDecreaseScreenReaderInformation': '{newWidth, plural, one {Tabellbredden har minskats till {newWidth,number} pixel.} other {Tabellbredden har minskats till {newWidth,number} pixlar.}}',
    'fabric.editor.tableResizeIncreaseScreenReaderInformation': "{newWidth, plural, one {Tabellbredden har \xf6kat till {newWidth,number} pixel.} other {Tabellbredden har \xf6kat till {newWidth,number} pixlar.}}",
    'fabric.editor.tableSelector': 'Tabellstorlek',
    'fabric.editor.tableSelector.description': "L\xe4gg till en tabell och anv\xe4nd popup-f\xf6nstret f\xf6r att v\xe4lja en anpassad storlek",
    'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} av {numberOfRows}',
    'fabric.editor.tableSizeSelectorPopup': "V\xe4ljare f\xf6r tabellstorlek",
    'fabric.editor.tables.adjustColumn': 'Justera kolumn',
    'fabric.editor.tables.columnResizeLast': "Du kan bara \xe4ndra storlek p\xe5 kolumnen till v\xe4nster.",
    'fabric.editor.tables.columnResizeOverflow': "Du kan bara \xe4ndra storlek p\xe5 kolumnen n\xe4r tabellen har en rullningslist.",
    'fabric.editor.tables.columnWidth': "{width, plural, one {Kolumnbredden har \xe4ndrats till {width} pixel.} other {Kolumnbredden har \xe4ndrats till {width} pixlar}}",
    'fabric.editor.tables.confirmDeleteLinkedModalMessage': "Om du raderar {nodeName} bryts allt som \xe4r kopplat till den.",
    'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Radera',
    'fabric.editor.tables.resizeStop': "Storleks\xe4ndring har avbrutits",
    'fabric.editor.tables.resizeTable': "\xc4ndra storlek p\xe5 tabell",
    'fabric.editor.tables.startedColumnResize': "Storleks\xe4ndring av kolumn har p\xe5b\xf6rjats",
    'fabric.editor.task': 'Uppgift',
    'fabric.editor.taskPlaceholder': "Skriv din \xe5tg\xe4rd och anv\xe4nd @ f\xf6r att tilldela n\xe5gon.",
    'fabric.editor.text.formatting.off': 'Textformatering av',
    'fabric.editor.textColor': "Textf\xe4rg {selectedColorName}",
    'fabric.editor.textColorTooltip': "Textf\xe4rg",
    'fabric.editor.textFormat': 'Formatera text',
    'fabric.editor.textFormatting': 'Textformatering',
    'fabric.editor.textStyles': 'Textstilar {blockTypeName}',
    'fabric.editor.textStylesTooltip': 'Textstilar',
    'fabric.editor.threeColumns': 'Layout med tre kolumner',
    'fabric.editor.threeColumnsWithLeftSidebars': "Layout med tre kolumner och sidopanel v\xe4nster",
    'fabric.editor.threeColumnsWithRightSidebars': "Layout med tre kolumner och sidopanel h\xf6ger",
    'fabric.editor.threeColumnsWithSidebars': 'Layout med tre kolumner och sidopaneler',
    'fabric.editor.time.ago': 'sedan',
    'fabric.editor.time.updated': 'Uppdaterad',
    'fabric.editor.time.viewed': 'Visad',
    'fabric.editor.toolbarAppears': "Verktygsf\xe4ltet visas",
    'fabric.editor.toolbarLabel': 'Redigerare',
    'fabric.editor.toolbarMediaTitle': "L\xe4gg till en bild, video eller fil",
    'fabric.editor.toolbarPositionFixedAtTop': "F\xe4st l\xe4ngst upp",
    'fabric.editor.toolbarPositionInline': 'I linje med texten',
    'fabric.editor.tooltip.blockPanel': 'en panel',
    'fabric.editor.tooltip.bulletList': 'en lista',
    'fabric.editor.tooltip.decisionList': 'en beslutslista',
    'fabric.editor.tooltip.defaultBlockNode': 'en blockeringsslutpunkt',
    'fabric.editor.tooltip.nestedExpand': 'en staplad expanderingsslutpunkt',
    'fabric.editor.tooltip.taskList': "ett \xe5tg\xe4rdsobjekt",
    'fabric.editor.turnInto': 'Omvandla till',
    'fabric.editor.twoColumns': "Layout med tv\xe5 kolumner",
    'fabric.editor.typeAhead.popupLabel': "Autof\xf6rslagsresultat",
    'fabric.editor.typeAhead.quickInsertInputLabel': "B\xf6rja skriva f\xf6r att s\xf6ka eller filtrera genv\xe4gsalternativ",
    'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': "S\xf6k",
    'fabric.editor.typeAhead.quickInsertPopupLabel': "Genv\xe4gar f\xf6r infogningar och formatering",
    'fabric.editor.typeahead.emojiInputLabel': "B\xf6rja skriva f\xf6r att s\xf6ka eller filtrera emojialternativ",
    'fabric.editor.typeahead.emojiListItemLabel': "Emoji {name} Textgenv\xe4g {shortcut}",
    'fabric.editor.typeahead.emojiPopupLabel': "Emojigenv\xe4gar",
    'fabric.editor.typeahead.mentionInputLabel': "B\xf6rja skriva f\xf6r att s\xf6ka efter anv\xe4ndare att tagga",
    'fabric.editor.typeahead.mentionPopupLabel': "Anv\xe4ndare som du kan tagga",
    'fabric.editor.typeahead.metionListItemLabel': "Anv\xe4ndare {name} @{shortName}",
    'fabric.editor.unableToLoadContent': "Vi kunde inte l\xe4sa in inneh\xe5llet",
    'fabric.editor.unableToOpenLink': "Det gick inte att \xf6ppna l\xe4nken",
    'fabric.editor.underline': 'Understruken',
    'fabric.editor.undo': "\xc5ngra",
    'fabric.editor.unknown.label': "Ok\xe4nd",
    'fabric.editor.unlink': "Ta bort l\xe4nk",
    'fabric.editor.unorderedList': 'Punktlista',
    'fabric.editor.unorderedList.description': 'Skapa en osorterad lista',
    'fabric.editor.unsupportedBlockContent': "Denna redigerare har inte st\xf6d f\xf6r visning av detta inneh\xe5ll",
    'fabric.editor.unsupportedContentTooltip': "Inneh\xe5llet \xe4r inte tillg\xe4ngligt i denna redigerare, detta bevaras n\xe4r du redigerar och sparar",
    'fabric.editor.unsupportedInlineContent': "Inneh\xe5ll utan st\xf6d",
    'fabric.editor.upDown': "Anv\xe4nd upp- och nedpilarna i f\xf6ljande inmatningsf\xe4lt f\xf6r att uppdatera datumet nedan",
    'fabric.editor.url': 'Visa URL',
    'fabric.editor.urlDescription': "Visa l\xe4nk som URL",
    'fabric.editor.urlTitle': 'URL',
    'fabric.editor.useMarkdown': "Anv\xe4nd Markdown",
    'fabric.editor.viewAndAddCommentsOnMedia': "Visa och l\xe4gg till kommentarer",
    'fabric.editor.viewCommentOnMedia': 'Visa kommentarer',
    'fabric.editor.viewMore': 'Visa mer',
    'fabric.editor.viewMoreAriaLabel': 'Visa alla element',
    'fabric.editor.visit': "\xd6ppna l\xe4nk i nytt f\xf6nster",
    'fabric.editor.warning': 'Varning',
    'fabric.editor.warningPanel': 'Varningspanel',
    'fabric.editor.warningPanel.description': "L\xe4gg till en varning i en f\xe4rgad panel",
    'fabric.editor.wrapLeft': "Radbyte v\xe4nster",
    'fabric.editor.wrapRight': "Radbyte h\xf6ger",
    'fabric.emoji.label': 'Emoji',
    'fabric.theme.blue': "Bl\xe5",
    'fabric.theme.bold-blue': "Starkbl\xe5",
    'fabric.theme.bold-gray': "Starkgr\xe5",
    'fabric.theme.bold-green': "Starkgr\xf6n",
    'fabric.theme.bold-magenta': 'Starkt magenta',
    'fabric.theme.bold-orange': 'Starkorange',
    'fabric.theme.bold-purple': 'Starklila',
    'fabric.theme.bold-red': "Starkr\xf6d",
    'fabric.theme.bold-teal': "Starkt bl\xe5gr\xf6n",
    'fabric.theme.bold-yellow': 'Starkgul',
    'fabric.theme.bolder-blue': "Starkare bl\xe5",
    'fabric.theme.bolder-gray': "Starkare gr\xe5",
    'fabric.theme.bolder-green': "Starkare gr\xf6n",
    'fabric.theme.bolder-magenta': 'Starkare magenta',
    'fabric.theme.bolder-orange': 'Starkare orange',
    'fabric.theme.bolder-purple': 'Starkare lila',
    'fabric.theme.bolder-red': "Starkare r\xf6d",
    'fabric.theme.bolder-teal': "Starkare m\xf6rkbl\xe5",
    'fabric.theme.bolder-yellow': 'Starkare gul',
    'fabric.theme.dark-blue': "M\xf6rkbl\xe5",
    'fabric.theme.dark-gray': "M\xf6rkgr\xe5",
    'fabric.theme.dark-green': "M\xf6rkgr\xf6n",
    'fabric.theme.dark-purple': "M\xf6rklila",
    'fabric.theme.dark-red': "M\xf6rkr\xf6d",
    'fabric.theme.dark-teal': "M\xf6rkteal",
    'fabric.theme.dark-yellow': "M\xf6rkgul",
    'fabric.theme.default': 'Standard',
    'fabric.theme.gray': "Gr\xe5",
    'fabric.theme.green': "Gr\xf6n",
    'fabric.theme.light-blue': "Ljusbl\xe5",
    'fabric.theme.light-gray': "Ljusgr\xe5",
    'fabric.theme.light-green': "Ljusgr\xf6n",
    'fabric.theme.light-purple': 'Ljuslila',
    'fabric.theme.light-red': "Ljusr\xf6d",
    'fabric.theme.light-teal': "Ljust bl\xe5gr\xf6n",
    'fabric.theme.light-yellow': 'Ljusgul',
    'fabric.theme.lime': 'Lime',
    'fabric.theme.magenta': 'Magenta',
    'fabric.theme.no-color': 'Ingen markering',
    'fabric.theme.orange': 'Orange',
    'fabric.theme.purple': 'Lila',
    'fabric.theme.red': "R\xf6d",
    'fabric.theme.subtle-blue': "D\xe4mpad bl\xe5",
    'fabric.theme.subtle-gray': "D\xe4mpad gr\xe5",
    'fabric.theme.subtle-green': "D\xe4mpad gr\xf6n",
    'fabric.theme.subtle-magenta': "D\xe4mpad magenta",
    'fabric.theme.subtle-orange': "D\xe4mpad orange",
    'fabric.theme.subtle-purple': "D\xe4mpad lila",
    'fabric.theme.subtle-red': "D\xe4mpad r\xf6d",
    'fabric.theme.subtle-teal': "D\xe4mpad bl\xe5gr\xf6n",
    'fabric.theme.subtle-yellow': "D\xe4mpad gul",
    'fabric.theme.teal': "Bl\xe5gr\xf6n",
    'fabric.theme.white': 'Vit',
    'fabric.theme.yellow': 'Gul',
    'fabrid.editor.rowNumbers': 'Radnummer',
    'rovo.agents.dropdown.title': 'Agenter',
    'rovo.agents.dropdown.viewAgents.label': 'Visa alla agenter'
};

});


//# sourceMappingURL=sv.e0d9f659.js.map
